/*
 * @Description:
 * @Date: 2022-04-11 20:43:05
 */
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'xrk-empty',
  render() {
    return (
      <div style={{ textAlign: 'center', paddingTop: '2rem' }}>
        <img
          style={{ width: '5rem' }}
          src={require('@/assets/img/default.png')}
          alt=""
        />
        <div style={{ fontSize: '0.35rem', marginTop: '0.3rem' }}>暂无数据</div>
      </div>
    );
  }
});
